export enum SeasonEntityTableFilters {
  Gender = "gender",
  AgeGroup = "ageGroup",
  Standard = "standard",
  Discipline = "discipline",
  Status = "status",
}
